const fileColorMap: Record<string, string> = {
  pdf: '#b50a00',
  powerpoint: '#C43E1C',
  photos: '#173B75',
  txt: '#005dc2',
  xlsx: '#19864c',
  movies: '#0067C0',
  onenote: '#771AA9',
  folder: '#ffb901',
  default: '#000',
};

const fileTypeMap: Record<string, string> = {
  pptx: 'powerpoint',
  ppt: 'powerpoint',
  pdf: 'pdf',
  bmp: 'photos',
  svg: 'photos',
  png: 'photos',
  jpg: 'photos',
  jpeg: 'photos',
  gif: 'photos',
  txt: 'txt',
  docx: 'txt',
  doc: 'txt',
  dotx: 'txt',
  xlsm: 'xlsx',
  xls: 'xlsx',
  xlsx: 'xlsx',
  avi: 'movies',
  mp4: 'movies',
  onepkg: 'onenote',
  onetoc2: 'onenote',
  one: 'onenote',
  folder: 'folder',
  default: 'all',
};

export function getFileExtension(fileName: string): string | null {
  return /\./.test(fileName)
    ? (fileName.split('.').pop() ?? '').toLowerCase().trim()
    : null;
}

export function isImgViewerRenderable(fileName: string): boolean {
  const extension = getFileExtension(fileName);
  return extension ? ['jpg', 'jpeg', 'png', 'gif'].includes(extension) : false;
}

export function isOfficeDocument(fileName: string): boolean {
  const extension = getFileExtension(fileName);
  return extension
    ? [
        'doc',
        'docx',
        'dotx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'pub',
        'csv',
        'xlsm',
      ].includes(extension)
    : false;
}

export function getFileColorUtils(fileExtension: string): string | null {
  const fileType = fileTypeMap[fileExtension] ?? fileTypeMap.default;
  return (fileType && fileColorMap[fileType]) ?? null;
}

export function getFileIconUtils(fileExtension: string): string | null {
  return fileTypeMap[fileExtension] ?? fileTypeMap.default ?? null;
}
